export const ar = {
  dir: 'rtl' as const,
  lang: 'ar',

  common: {
    appName: 'سيريا 14',
    tagline: 'افتح بابك لمنزل أحلامك',
    loading: 'جاري التحميل...',
    error: 'حدث خطأ',
    retry: 'إعادة المحاولة',
    save: 'حفظ',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    delete: 'حذف',
    edit: 'تعديل',
    view: 'عرض',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    search: 'بحث',
    filter: 'تصفية',
    clear: 'مسح',
    apply: 'تطبيق',
    close: 'إغلاق',
    yes: 'نعم',
    no: 'لا',
    or: 'أو',
    and: 'و',
    all: 'الكل',
    noResults: 'لا توجد نتائج',
    required: 'مطلوب',
    optional: 'اختياري',
    viewAll: 'عرض الكل',
    savedToFavorites: 'أضيف إلى المفضلة',
    removedFromFavorites: 'حذف من المفضلة',
    skipToContent: 'انتقل إلى المحتوى الرئيسي',
  },

  nav: {
    home: 'الرئيسية',
    properties: 'العقارات',
    offices: 'المكاتب',
    search: 'البحث',
    contact: 'اتصل بنا',
    login: 'تسجيل الدخول',
    register: 'إنشاء حساب',
    logout: 'تسجيل الخروج',
    dashboard: 'لوحة التحكم',
    account: 'حسابي',
    favorites: 'المفضلة',
    adminPanel: 'لوحة الإدارة',
  },

  auth: {
    login: 'تسجيل الدخول',
    register: 'إنشاء حساب',
    logout: 'تسجيل الخروج',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    fullName: 'الاسم الكامل',
    phone: 'رقم الهاتف',
    forgotPassword: 'نسيت كلمة المرور؟',
    resetPassword: 'إعادة تعيين كلمة المرور',
    rememberMe: 'تذكرني',
    loginWithGoogle: 'الدخول بحساب Google',
    noAccount: 'ليس لديك حساب؟',
    hasAccount: 'لديك حساب بالفعل؟',
    signUpHere: 'سجل هنا',
    signInHere: 'سجل دخولك هنا',
    passwordMinLength: 'كلمة المرور يجب أن تكون 8 أحرف على الأقل',
    passwordsNotMatch: 'كلمات المرور غير متطابقة',
    invalidEmail: 'البريد الإلكتروني غير صالح',
    loginSuccess: 'تم تسجيل الدخول بنجاح',
    registerSuccess: 'تم إنشاء الحساب بنجاح',
    logoutSuccess: 'تم تسجيل الخروج',
    sendResetLink: 'إرسال رابط إعادة التعيين',
    checkEmail: 'تحقق من بريدك الإلكتروني للحصول على رابط إعادة التعيين',
    showPassword: 'إظهار كلمة المرور',
    hidePassword: 'إخفاء كلمة المرور',
    profile_not_setup: 'الحساب غير مكتمل، يرجى التواصل مع الدعم.',
  },

  roles: {
    user: 'مستخدم',
    pending_office: 'مكتب قيد المراجعة',
    office: 'مكتب عقاري',
    admin: 'مدير النظام',
    subadmin: 'مشرف',
  },

  property: {
    property: 'عقار',
    properties: 'عقارات',
    title: 'عنوان العقار',
    description: 'الوصف',
    price: 'السعر',
    category: 'الفئة',
    listingType: 'نوع الإعلان',
    sale: 'للبيع',
    rent: 'للإيجار',
    bedrooms: 'غرف النوم',
    bathrooms: 'الحمامات',
    area: 'المساحة',
    city: 'المدينة',
    district: 'الحي',
    address: 'العنوان',
    amenities: 'المميزات',
    images: 'الصور',
    status: 'الحالة',
    statuses: {
      draft: 'مسودة',
      pending: 'قيد المراجعة',
      active: 'نشط',
      rejected: 'مرفوض',
      hidden: 'مخفي',
      sold: 'مباع',
      rented: 'مؤجر',
      inactive: 'غير نشط',
      archived: 'مؤرشف',
    },
    categories: {
      residential: 'سكني',
      commercial: 'تجاري',
      land: 'أرض',
      industrial: 'صناعي',
      farm_pool: 'مزارع مع مسبح',
      tourism: 'فندقي',
    },
    addProperty: 'إضافة عقار',
    editProperty: 'تعديل العقار',
    deleteProperty: 'حذف العقار',
    viewDetails: 'عرض التفاصيل',
    contactOffice: 'التواصل مع المكتب',
    whatsapp: 'واتساب',
    noProperties: 'لا توجد عقارات',
    noPropertiesHint: 'أضف عقارك الأول للبدء في النشر',
    sqm: 'م²',
    currency: {
      SYP: 'ل.س',
      USD: 'دولار',
    },
    rooms: 'الغرف',
    floor: 'الطابق',
    totalFloors: 'مجموع الطوابق',
    buildingAge: 'عمر البناء',
    furnished: 'مفروش',
    unfurnished: 'غير مفروش',
    propertyType: 'نوع العقار',
    direction: 'الاتجاه',
    view: 'الإطلالة',
    ownershipType: 'نوع الملكية',
    paymentMethod: 'طريقة الدفع',
    relatedProperties: 'عقارات مشابهة',
    callNow: 'اتصل الآن',
    emailContact: 'البريد الإلكتروني',
    features: 'المزايا',
    specifications: 'المواصفات',
    years: 'سنوات',
    kitchens: 'المطابخ',
    livingRooms: 'غرف الجلوس',
    linkCopied: 'تم نسخ الرابط',
    shareProperty: 'مشاركة',
    reference: 'الرقم المرجعي:',
    referenceCopy: 'نسخ الرقم المرجعي',
    referenceCopied: 'تم نسخ الرقم المرجعي',

    gallery: {
      prev: 'الصورة السابقة',
      next: 'الصورة التالية',
      goToImage: 'الانتقال إلى الصورة {n}',
      viewImage: 'عرض الصورة {n}',
    },
    form: {
      title: 'إضافة عقار جديد',
      subtitle: 'املأ التفاصيل لنشر عقارك',
      editTitle: 'تعديل العقار',
      editSubtitle: 'حدّث تفاصيل إعلانك',
      fixErrors: 'يرجى تصحيح الحقول المميّزة باللون الأحمر قبل النشر',
    },
    section: {
      basic: 'المعلومات الأساسية',
      location: 'الموقع',
      details: 'تفاصيل العقار',
      features: 'المميزات',
      contact: 'بيانات التواصل',
      photos: 'الصور',
    },
    field: {
      title: 'عنوان الإعلان',
      description: 'الوصف',
      propertyType: 'نوع العقار',
      listingType: 'نوع العرض',
      price: 'السعر',
      currency: 'العملة',
      governorate: 'المحافظة',
      area: 'المنطقة',
      address: 'العنوان التفصيلي',
      size: 'المساحة (م²)',
      bedrooms: 'غرف النوم',
      bathrooms: 'الحمامات',
      livingRooms: 'غرف الجلوس',
      kitchens: 'المطابخ',
      floor: 'الطابق',
      totalFloors: 'عدد الطوابق الكلي',
      buildingAge: 'عمر البناء (سنوات)',
      direction: 'الاتجاه',
      view: 'الإطلالة',
      paymentMethod: 'طريقة الدفع',
      ownershipType: 'نوع الملكية',
      contactPhone: 'رقم الهاتف',
      whatsapp: 'واتساب',
      videoUrl: 'رابط الفيديو (اختياري)',
    },
    types: {
      apartment: 'شقة',
      villa: 'فيلا',
      land: 'أرض',
      shop: 'محل تجاري',
      office: 'مكتب',
      building: 'بناء كامل',
      farm_pool: 'مزارع مع مسبح',
      tourism: 'فندقي',
      other: 'أخرى',
    },
    feature: {
      parking: 'موقف سيارات',
      elevator: 'مصعد',
      balcony: 'شرفة',
      garden: 'حديقة',
      pool: 'مسبح',
      furnished: 'مفروش',
      ac: 'تكييف',
      heating: 'تدفئة',
      security: 'حراسة',
      storage: 'غرفة تخزين',
    },
    photos: {
      dropHint: 'اسحب الصور هنا أو اضغط للاختيار',
      coverBadge: 'الغلاف',
      setCover: 'تعيين كغلاف',
      fileTooLarge: 'الصورة كبيرة جداً (الحد 5 ميجابايت)',
      invalidType: 'نوع الملف غير مدعوم',
      counter: '{n} / 15',
    },
    actions: {
      publish: 'نشر الإعلان',
      cancel: 'إلغاء',
      publishing: 'جارٍ النشر...',
      save: 'حفظ التغييرات',
      saving: 'جارٍ الحفظ...',
      hide: 'إخفاء',
      show: 'إظهار',
      viewPublic: 'عرض الصفحة',
      hiddenSuccess: 'تم إخفاء العقار',
      shownSuccess: 'تم إظهار العقار',
    },
    success: {
      created: 'تم نشر العقار بنجاح',
      updated: 'تم تحديث العقار بنجاح',
    },
    error: {
      createFailed: 'تعذّر نشر العقار',
      updateFailed: 'تعذّر تحديث العقار',
      notFound: 'العقار غير موجود',
    },
    warning: {
      partialImages: 'تم إنشاء العقار، لكن فشل تحميل بعض الصور',
      partialImagesUpdate: 'تم تحديث العقار، لكن فشل تحميل بعض الصور الجديدة',
    },
    directions: {
      north: 'شمال',
      south: 'جنوب',
      east: 'شرق',
      west: 'غرب',
      northeast: 'شمال شرق',
      northwest: 'شمال غرب',
      southeast: 'جنوب شرق',
      southwest: 'جنوب غرب',
    },
    views: {
      street: 'شارع',
      garden: 'حديقة',
      sea: 'بحر',
      mountain: 'جبل',
      city: 'مدينة',
    },
    paymentMethods: {
      cash: 'نقداً',
      installments: 'تقسيط',
      mixed: 'نقد وتقسيط',
    },
    ownershipTypes: {
      freehold: 'تمليك حر',
      usufruct: 'حق انتفاع',
      waqf: 'وقف',
    },
    farm: {
      pricing: 'أسعار الحجز',
      availability: 'التوفر',
      dailyPrice: 'سعر الليلة',
      weeklyPrice: 'سعر الأسبوع',
      monthlyPrice: 'سعر الشهر',
      minDays: 'أقل عدد أيام',
      maxDays: 'أكثر عدد أيام',
      atLeastOnePrice: 'اختر سعراً واحداً على الأقل',
      maxLessThanMin: 'أكثر عدد أيام يجب أن يكون أكبر من أو يساوي الأقل',
    },
  },

  bookings: {
    title: 'الحجوزات',
    subtitle: 'إدارة طلبات حجز المزارع',
    tabs: {
      all: 'الكل',
      pending: 'قيد المراجعة',
      confirmed: 'مؤكدة',
      past: 'سابقة',
    },
    status: {
      pending: 'قيد المراجعة',
      confirmed: 'مؤكد',
      rejected: 'مرفوض',
      cancelled: 'ملغي',
      completed: 'مكتمل',
    },
    list: {
      customer: 'العميل',
      dates: 'التواريخ',
      nights: '{n} ليالٍ',
      dayUse: 'استخدام يومي',
      note: 'ملاحظة العميل',
      empty: 'لا توجد حجوزات',
    },
    actions: {
      confirm: 'تأكيد الحجز',
      reject: 'رفض الحجز',
      details: 'التفاصيل',
    },
    confirm: {
      title: 'تأكيد الحجز',
      noteLabel: 'ملاحظة للعميل (اختياري)',
    },
    reject: {
      title: 'رفض الحجز',
      noteLabel: 'سبب الرفض (مطلوب)',
      notePlaceholder: 'على الأقل 5 أحرف',
    },
    toast: {
      confirmed: 'تم تأكيد الحجز',
      rejected: 'تم رفض الحجز',
      failed: 'فشل تحديث الحالة',
    },
    customer: {
      requestTitle: 'اطلب حجزاً',
      perNight: 'لليلة',
      selectDates: 'اختر تواريخك',
      nights: '{n} ليالٍ',
      total: 'الإجمالي',
      noteLabel: 'ملاحظة للمكتب (اختياري)',
      notePlaceholder: 'أي أسئلة أو طلبات؟',
      request: 'إرسال طلب الحجز',
      requestSent: 'تم إرسال الطلب',
      requestSentDesc: 'سيراجع المكتب طلبك ويؤكده قريباً.',
      loginToBook: 'سجّل الدخول للحجز',
      selectRange: 'يرجى اختيار تاريخ الوصول والمغادرة.',
      selectDate: 'يرجى اختيار تاريخ.',
      selectCheckout: 'اختر الآن تاريخ المغادرة',
      dayUse: 'استخدام يومي',
      dayUseHint: 'الحجز اليومي متاح — اختر يوماً واحداً',
      checkinAt: 'دخول {time}',
      checkoutAt: 'خروج {time}',
      arrivalDate: 'تاريخ الوصول',
      arrivalTime: 'وقت الوصول',
      departureDate: 'تاريخ المغادرة',
      departureTime: 'وقت المغادرة',
      arrival: 'الوصول',
      departure: 'المغادرة',
      summary: 'ملخص الحجز',
      duration: '{n} ساعة',
      minHours: 'الحد الأدنى للمدة {n} ساعات.',
      invalidTimes: 'يجب أن يكون وقت المغادرة بعد وقت الوصول.',
      minNights: 'الحد الأدنى للإقامة {n} ليالٍ.',
      maxNights: 'الحد الأقصى للإقامة {n} ليالٍ.',
      myBookings: 'حجوزاتي',
      mySubtitle: 'تابع وأدر طلبات حجزك',
      cancel: 'إلغاء الحجز',
      cancelConfirm: 'إلغاء هذا الحجز؟ لا يمكن التراجع عن ذلك.',
      keepBooking: 'الاحتفاظ بالحجز',
      empty: 'لم تقم بأي حجوزات بعد.',
      toast: {
        requestSuccess: 'تم إرسال طلب الحجز',
        cancelled: 'تم إلغاء الحجز',
        overlap: 'تم حجز هذه التواريخ للتو. يرجى اختيار فترة أخرى.',
        failed: 'تعذّر إكمال طلبك',
      },
    },
  },

  calendar: {
    legend: {
      available: 'متاح',
      booked: 'محجوز',
    },
  },

  office: {
    office: 'مكتب',
    offices: 'مكاتب',
    officeName: 'اسم المكتب',
    officeSlug: 'الرابط المختصر',
    description: 'الوصف',
    city: 'المدينة',
    phone: 'الهاتف',
    logo: 'الشعار',
    companyDocument: 'وثيقة الشركة',
    idDocument: 'وثيقة الهوية',
    applyAsOffice: 'التقدم كمكتب عقاري',
    applyNow: 'تقديم الطلب الآن',
    applicationStatus: 'حالة الطلب',
    applicationPending: 'طلبك قيد المراجعة',
    applicationApproved: 'تم قبول طلبك',
    applicationRejected: 'تم رفض طلبك',
    applicationSubmitted: 'تم إرسال طلبك بنجاح',
    reapply: 'تقديم طلب جديد',
    rejectionReason: 'سبب الرفض',
    slugHint: 'سيظهر في رابط صفحتك، مثل: /offices/my-office',
    whatsapp: 'واتساب',
    uploadLogo: 'رفع شعار المكتب',
    uploadDocument: 'رفع وثيقة الشركة',
    uploadId: 'رفع وثيقة الهوية',
    dashboard: 'لوحة تحكم المكتب',
    myProperties: 'عقاراتي',
    noOffice: 'لا توجد مكاتب',
    propertiesBy: 'عقارات مكتب',
    noOfficeProperties: 'لا توجد عقارات نشطة لهذا المكتب حتى الآن.',
    profile: {
      title: 'ملف المكتب',
      subtitle: 'بيانات مكتبك وإحصائياتك',
    },
    status: {
      approved: 'معتمد',
      pending: 'قيد المراجعة',
      rejected: 'مرفوض',
    },
    stats: {
      total: 'إجمالي العقارات',
      active: 'نشطة',
      hidden: 'مخفية',
      sold: 'مباعة/مؤجرة',
    },
    meta: {
      registered: 'تاريخ التسجيل',
      approved: 'تاريخ الاعتماد',
      officeId: 'معرّف المكتب',
    },
    form: {
      save: 'حفظ التغييرات',
      saving: 'جارٍ الحفظ...',
      saved: 'تم حفظ التغييرات',
    },
  },

  admin: {
    dashboard: 'لوحة الإدارة',
    users: 'المستخدمون',
    offices: 'المكاتب',
    properties: 'العقارات',
    applications: 'طلبات المكاتب',
    approve: 'قبول',
    reject: 'رفض',
    approved: 'مقبول',
    rejected: 'مرفوض',
    pending: 'قيد المراجعة',
    confirmApprove: 'هل تريد قبول هذا الطلب؟',
    confirmReject: 'هل تريد رفض هذا الطلب؟',
    enterRejectionReason: 'أدخل سبب الرفض',
    approveSuccess: 'تم قبول الطلب بنجاح',
    rejectSuccess: 'تم رفض الطلب',
    viewDocuments: 'عرض الوثائق',
    applicantName: 'اسم مقدم الطلب',
    submittedAt: 'تاريخ التقديم',
    reviewedAt: 'تاريخ المراجعة',
    allStatuses: 'جميع الحالات',
    pendingApplications: 'الطلبات المعلقة',
    rejectionReason: 'سبب الرفض',
    totalUsers: 'إجمالي المستخدمين',
    totalOffices: 'إجمالي المكاتب',
    totalProperties: 'إجمالي العقارات',
    pendingReview: 'قيد المراجعة',
    deleteUser: 'حذف المستخدم',
    confirmDeleteUser: 'هل تريد حذف هذا المستخدم؟ لا يمكن التراجع عن هذا الإجراء.',
    deleteUserSuccess: 'تم حذف المستخدم',
    demoteToUser: 'تحويل إلى مستخدم',
    confirmDemoteToUser: 'هل تريد تغيير دور هذا المستخدم إلى مستخدم عادي؟',
    demoteSuccess: 'تم تحديث الدور بنجاح',
    documents: 'الوثائق',
    noDocuments: 'لا توجد وثائق مرفوعة',
    // إلغاء تفعيل المستخدم
    deactivateUser: 'تعطيل المستخدم',
    confirmDeactivateUser:
      'تعطيل هذا المستخدم؟ لن يظهر في قائمة المستخدمين ولن يتمكن من تسجيل الدخول.',
    deactivateSuccess: 'تم تعطيل المستخدم',
    reactivateUser: 'إعادة تفعيل المستخدم',
    reactivateSuccess: 'تم إعادة تفعيل المستخدم',
    // إدارة الأدوار
    changeRole: 'تغيير الدور',
    selectNewRole: 'اختر الدور الجديد',
    confirmChangeRole: 'تغيير الدور؟',
    changeRoleSuccess: 'تم تحديث الدور بنجاح',
    promoteToSubadmin: 'ترقية إلى مشرف',
    promoteToOffice: 'ترقية إلى مكتب',
    // إدارة المكاتب
    deleteOffice: 'حذف المكتب',
    confirmDeleteOffice: 'حذف هذا المكتب وجميع بياناته؟ لا يمكن التراجع.',
    deleteOfficeSuccess: 'تم حذف المكتب بنجاح',
    suspendOffice: 'تعليق المكتب',
    confirmSuspendOffice: 'تعليق هذا المكتب؟ لن يتمكن من نشر العقارات.',
    suspendSuccess: 'تم تعليق المكتب',
    unsuspendOffice: 'إعادة تفعيل المكتب',
    unsuspendSuccess: 'تم إعادة تفعيل المكتب',
    makeUnavailable: 'تعيين كغير متاح',
    makeAvailable: 'تعيين كمتاح',
    toggleAvailabilitySuccess: 'تم تحديث حالة التوفر',
    approveOffice: 'الموافقة على المكتب',
    rejectOffice: 'رفض المكتب',
    confirmApproveOffice: 'الموافقة على هذا المكتب؟ سيتلقى المالك إشعاراً ويمكنه البدء في النشر.',
    confirmRejectOffice: 'رفض هذا المكتب؟',
    approveOfficeSuccess: 'تمت الموافقة على المكتب',
    rejectOfficeSuccess: 'تم رفض المكتب',
    officeOwner: 'المالك',
    propertyCount: 'العقارات',
    // إدارة العقارات
    deleteProperty: 'حذف العقار',
    confirmDeleteProperty: 'حذف هذا العقار نهائياً؟ لا يمكن التراجع.',
    deletePropertySuccess: 'تم حذف العقار بنجاح',
    unpublish: 'إلغاء النشر',
    republish: 'إعادة النشر',
    unpublishSuccess: 'تم إلغاء نشر العقار',
    republishSuccess: 'تم إعادة نشر العقار',
    propertyRef: 'رقم المرجع',
    ownerOffice: 'المكتب',
    actions: 'الإجراءات',
    suspended: 'معلق',
    // Office soft-hide / restore
    hideOffice: 'إخفاء المكتب',
    confirmHideOffice: 'إخفاء هذا المكتب؟ سيُزال من الموقع العام. تُحفظ جميع البيانات والعقارات.',
    hideOfficeSuccess: 'تم إخفاء المكتب',
    restoreOffice: 'استعادة المكتب',
    confirmRestoreOffice: 'استعادة هذا المكتب إلى حالته السابقة؟',
    restoreOfficeSuccess: 'تم استعادة المكتب',
    hidden: 'مخفي',
    hiddenOffices: 'المكاتب المخفية',
    activeOffices: 'المكاتب النشطة',
    // Users tabs
    activeUsers: 'المستخدمون النشطون',
    deactivatedUsers: 'المستخدمون المعطلون',
    deactivationDate: 'تاريخ التعطيل',
    inquiries: 'الاستفسارات',
    // Property archive / restore
    archiveProperty: 'أرشفة العقار',
    confirmArchiveProperty:
      'أرشفة هذا العقار؟ سيُزال من جميع القوائم. تُحفظ الصور والمفضلات والاستفسارات.',
    archiveSuccess: 'تم أرشفة العقار',
    restoreProperty: 'استعادة العقار',
    confirmRestoreProperty: 'استعادة هذا العقار إلى حالة "غير منشور"؟',
    restorePropertySuccess: 'تم استعادة العقار',
    archived: 'مؤرشف',
    archivedProperties: 'العقارات المؤرشفة',
    activeProperties: 'العقارات النشطة',
    publish: 'نشر',
    publishSuccess: 'تم نشر العقار',
  },

  pages: {
    home: 'الرئيسية',
    search: 'نتائج البحث',
    properties: 'جميع العقارات',
    propertyDetail: 'تفاصيل العقار',
    offices: 'المكاتب العقارية',
    officeDetail: 'تفاصيل المكتب',
    contact: 'اتصل بنا',
    favorites: 'المفضلة',
    savedProperties: 'العقارات المحفوظة',
    savedOffices: 'المكاتب المحفوظة',
    noSavedProperties: 'لا توجد عقارات محفوظة بعد',
    noSavedOffices: 'لا توجد مكاتب محفوظة بعد',
    latestProperties: 'أحدث العقارات',
    account: 'حسابي',
    notFound: 'الصفحة غير موجودة',
    notFoundDesc: 'عذراً، الصفحة التي تبحث عنها غير موجودة.',
    goHome: 'العودة للرئيسية',
  },

  search: {
    placeholder: 'ابحث عن عقار...',
    results: 'نتائج البحث',
    noResults: 'لا توجد عقارات مطابقة لبحثك',
    filters: 'خيارات التصفية',
    advancedSearch: 'بحث متقدم',
    priceRange: 'نطاق السعر',
    minPrice: 'الحد الأدنى للسعر',
    maxPrice: 'الحد الأقصى للسعر',
    priceFrom: 'السعر من',
    priceTo: 'السعر إلى',
    areaFrom: 'المساحة من',
    areaTo: 'المساحة إلى',
    anyCity: 'أي مدينة',
    anyCategory: 'أي فئة',
    anyType: 'الكل',
    anyGovernorate: 'المحافظة',
    anyArea: 'المنطقة',
    propertyType: 'نوع العقار',
    furnished: 'الفرش',
    furnishedYes: 'مفروش',
    furnishedNo: 'غير مفروش',
    floor: 'الطابق',
    rooms: 'الغرف',
    bathrooms: 'الحمامات',
    heroTitle: 'اعثر على عقارك المثالي في سوريا',
    heroSubtitle: 'آلاف العقارات للبيع والإيجار في جميع أنحاء سوريا',
  },

  home: {
    featured: {
      title: 'العقارات المميزة',
      subtitle: 'تصفح أحدث العروض',
      view_all: 'عرض كل العقارات',
    },
    referenceSearch: {
      label: 'ابحث بالرقم المرجعي',
      placeholder: 'مثال: SY14-00123',
      submit: 'بحث',
      invalid: 'صيغة الرقم المرجعي غير صحيحة',
      notFound: 'لم يتم العثور على عقار بهذا الرقم',
    },
  },

  blog: {
    sectionTitle: 'من مدونتنا',
    sectionSubtitle: 'مقالات عن الثقافة السورية والتاريخ والاستثمار العقاري',
    readMore: 'اقرأ المزيد',
    viewAll: 'عرض جميع المقالات',
    allArticles: 'جميع المقالات',
    minRead: 'للقراءة',
    author: 'فريق سيريا 14',
    shareArticle: 'شارك المقال',
    relatedArticles: 'مقالات ذات صلة',
    tableOfContents: 'جدول المحتويات',
    backToBlog: 'العودة إلى المدونة',
    notFound: 'المقال غير موجود',
    pageTitle: 'المدونة',
    pageSubtitle: 'أحدث المقالات حول الثقافة والتاريخ والعقارات في سوريا',
  },

  errors: {
    generic: 'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.',
    notFound: 'العنصر غير موجود.',
    unauthorized: 'غير مصرح لك بالوصول لهذه الصفحة.',
    forbidden: 'ممنوع الوصول.',
    network: 'خطأ في الاتصال بالشبكة.',
  },

  account: {
    title: 'الحساب',
    info: {
      heading: 'معلومات الحساب',
      accountType: 'نوع الحساب',
      realEstateOffice: 'مكتب عقاري',
      joined: 'تاريخ الانضمام',
    },
    actions: {
      editProfile: 'تعديل الملف الشخصي',
    },
    security: {
      heading: 'الأمان',
    },
    notifications: {
      heading: 'إشعارات البريد',
      inquiries: 'استفسارات العقارات الجديدة',
      system: 'إعلانات النظام',
      saved: 'تم الحفظ',
    },
  },

  notifications: {
    title: 'الإشعارات',
    empty: 'لا توجد إشعارات بعد',
    markAllRead: 'تعليم الكل كمقروء',
    viewAll: 'عرض الكل',
    justNow: 'الآن',
  },

  validation: {
    required: 'هذا الحقل مطلوب',
    tooShort: 'النص قصير جداً',
    tooLong: 'النص طويل جداً',
    notANumber: 'يجب أن يكون رقماً',
    mustBePositive: 'يجب أن يكون رقماً موجباً',
    invalidUrl: 'الرابط غير صالح',
    invalidPhone: 'رقم الهاتف غير صالح',
    atLeastOneImage: 'يجب إضافة صورة واحدة على الأقل',
    invalidEmail: 'البريد الإلكتروني غير صالح',
    atLeastOne: 'اختر خياراً واحداً على الأقل',
  },

  register: {
    sectionAccount: 'بيانات الحساب',
    sectionOffice: 'بيانات المكتب',
    sectionDocuments: 'الوثائق الرسمية',
    documentsHint: 'مطلوبة لمراجعة وقبول الطلب',
    companyDocLabel: 'السجل التجاري أو وثيقة الشركة الرسمية',
    idDocLabel: 'وثيقة الهوية الشخصية',
    submitOffice: 'تسجيل وتقديم طلب المكتب',
    chooseType: 'اختر نوع الحساب للمتابعة',
    userTitle: 'مستخدم عادي',
    userDescription: 'للأفراد الراغبين في البحث عن عقارات وحفظ المفضلة',
    officeTitle: 'مكتب عقاري',
    officeDescription: 'للمكاتب الراغبة في نشر عقاراتها وإدارة قوائمها',
    userFormTitle: 'إنشاء حساب مستخدم',
    officeFormTitle: 'تسجيل مكتب عقاري',
    selectCity: 'اختر المدينة',
    invalidDocType: 'يرجى رفع صورة أو ملف PDF',
    docTooLarge: 'الحجم الأقصى {max}MB',
    docHint: 'JPG, PNG, PDF — الحجم الأقصى {max}MB',
    cityRequired: 'يرجى اختيار المدينة',
    companyDocRequired: 'يرجى رفع وثيقة الشركة الرسمية',
    idDocRequired: 'يرجى رفع وثيقة الهوية',
    officeSuccess: {
      title: 'تم تقديم الطلب بنجاح',
      body: 'طلب مكتبك قيد المراجعة. ستتلقى إشعاراً بمجرد الموافقة عليه.',
      cta: 'الذهاب إلى الصفحة الرئيسية',
    },
  },

  contact: {
    subtitle: 'يسعدنا سماعك والرد على استفساراتك',
    form: {
      name: 'الاسم الكامل',
      contact: 'البريد الإلكتروني أو رقم الهاتف',
      message: 'رسالتك',
      messagePlaceholder: 'اكتب رسالتك هنا...',
      send: 'إرسال الرسالة',
      sending: 'جاري الإرسال...',
      successTitle: 'تم إرسال رسالتك بنجاح',
      successBody: 'سنتواصل معك في أقرب وقت ممكن.',
      sendAnother: 'إرسال رسالة أخرى',
    },
    info: {
      heading: 'معلومات التواصل',
      phone: '+963 992 957 996',
      whatsapp: '+963 992 957 996',
      email: 'info@syria14.com',
      address: 'دمشق، سوريا',
      hours: 'الأحد – الخميس، 9 ص – 5 م',
      phoneLabel: 'الهاتف',
      whatsappLabel: 'واتساب',
      emailLabel: 'البريد الإلكتروني',
      addressLabel: 'العنوان',
      hoursLabel: 'ساعات العمل',
    },
  },
} as const;

// Widen all string literals to `string` so other locales can satisfy this type
type StringValues<T> = T extends string ? string : { [K in keyof T]: StringValues<T[K]> };

export type Translations = {
  dir: 'rtl' | 'ltr';
  lang: string;
} & StringValues<Omit<typeof ar, 'dir' | 'lang'>>;
